import { Notification } from 'element-ui';
const client = require('pusher-js');
import Echo from 'laravel-echo';
import store from '../store/store';
import config from '../config/env';

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: config('PUSHER_APP_KEY'),
  cluster: 'eu',
});

window.Echo.channel('representativePrices')
  .listen('.updated', (data) => {
    if (data && data.message) {
      store.dispatch('representativePrice/fetchAll');
      Notification.success(data.message);
    }
  });
window.Echo.channel('representativeTasks')
  .listen('.created', (data) => {
    if (data && data.message) {
      store.dispatch('task/fetchAll');
      Notification.success(data.message);
    }
  });
